export default "__VITE_ASSET__BWHWzgOO__"